import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
// componentes
import Form from "./Form";
import MessageUser from "./MessageUser";
// service
import { verifySurveyByUser } from "../../services/survey";

export default function VotorantimQuiz1() {
  // parametros
  const [searchParams] = useSearchParams();
  // usuário
  const [user, setUser] = useState(null);
  // respondido
  const [step, setStep] = useState(null);

  async function VerifyUser({ idPart, idEvent }) {
    try {
      const res = await verifySurveyByUser({
        eventId: idEvent,
        loginId: idPart,
        question: "O que é o Nação VC?",
      });

      if (res.message === "QUESTION_AVAILABLE") {
        setStep(1);
      } else if (res.message === "QUESTION_ANSWERED") {
        setStep(2);
      } else setStep(3);
    } catch (error) {}
  }

  useEffect(() => {
    if (window.location.search !== "") {
      const idPart = searchParams.get("idPart");
      const idEvent = searchParams.get("idEvent");

      if (idPart && idEvent) {
        setUser({ idPart, idEvent });
        VerifyUser({ idPart, idEvent });
      }
    }
  }, []);

  return (
    <>
      <section className="section-votorantim">
        {step === 1 && <Form user={user} />}
        {(step === 2 || step === 3) && <MessageUser step={step} />}
      </section>
    </>
  );
}
